import { createReducer, on } from "@ngrx/store";
import {
  completedByAgeRangeAndGenderForAd,
  getViewsByGenderForAd,
  globalStatisticsByAdHashedId,
  invokeGlobalStatisticsForLP,
  invokeViewsByAgeRangeAndGenderByAd,
  redirectionByAgeAndGenderForAd,
  resultCompletedByGenderDemographicForLocationPartner,
  resultGlobalStatisticsForLP,
  resultRetentionRateByWeeks,
  resultSummaryStatics,
  resultUniqueConsumers,
  resultGenderAgeStatistics,
  viewsByAgeRangeAndGenderByAd,
  resultRetainedConsumers,
  invokeUniqueConsumers,
  invokeAllSummaryChartInDateBetween,
  invokeSummaryStaticsInDateBetweenForAd,
  invokeSummaryStaticsInDateBetweenForLP,
  invokeRetentionRateByWeeks,
  invokeRetainedConsumers,
  resultConsumersByAgeAndGenderForLP,
  invokeSummaryChartInDayForLP,
  invokeSummaryChartInDayForAd,
  invokeCompletedByGenderDemographicForLocationPartner,
  invokeViewsByGenderDemographicForLocationPartners,
  invokeCompletedByAgeRangeAndGenderForAd,
  invokeSummaryChartInDay,
  invokeFranchiseSummaryStatisticsBetweenDates,
  resultGlobalStatistics,
  invokeFranchiseGlobalStatistics,
  invokeLocationPartnerGlobalStatistics,
  invokeClicksByGenderDemographicForLocationPartner,
} from "./statistics.actions";
import { StatisticsStateInterface } from "./statisticsState.interface";

export const initialState: Readonly<StatisticsStateInterface> = {
  loading: false,
  ageStatistics: null,
  gender: null,
  summaryStatistics: null,
  loadingSummaryStatistics: true,
  genderAgeStatistics: null,
  genderAgeStatisticsForMap: null,
  globalStatistics: null,
  resultGlobalStatisticsForLP: null,
  uniqueConsommers: null,
  loadingConsumers: false,
  retentionRate: null,
  loadingGlobalStatics: true,
  consumers: 0,
  loadingRetainedConsumer: true,
  loadingByAgeRangeAndGenderByAd: true,

  audienceStatistics: null,
  loadingRetentionRate: true
};

export const StatisticsReducer = createReducer(
  initialState,
  on(invokeAllSummaryChartInDateBetween, (state) => ({
    ...state,
    loadingSummaryStatistics: true,
  })),
  on(invokeSummaryChartInDay, (state) => ({
    ...state,
    loadingSummaryStatistics: true,
  })),
  on(resultSummaryStatics, (state, { summaryStatistic }) => ({
    ...state,
    summaryStatistics: summaryStatistic,
    loadingSummaryStatistics: false,
    loadingInDay: false,
  })),
  on(invokeSummaryStaticsInDateBetweenForAd, (state) => ({
    ...state,
    loadingSummaryStatistics: true,
  })),
  on(invokeSummaryStaticsInDateBetweenForLP, (state) => ({
    ...state,
    loadingSummaryStatistics: true,
  })),
  on(getViewsByGenderForAd, (state, { gender }) => ({
    ...state,
    gender: gender,
    loading: false,
  })),
  on(viewsByAgeRangeAndGenderByAd, (state, { genderAgeStatistics }) => ({
    ...state,
    genderAgeStatistics: genderAgeStatistics,
    loadingByAgeRangeAndGenderByAd: false,
  })),
  on(redirectionByAgeAndGenderForAd, (state, { genderAgeStatistics }) => ({
    ...state,
    genderAgeStatistics: genderAgeStatistics,
    loading: false,
  })),

  on(globalStatisticsByAdHashedId, (state, { globalStatistics }) => ({
    ...state,
    globalStatistics: globalStatistics,
    loading: false,
  })),
  on(completedByAgeRangeAndGenderForAd, (state, { genderAgeStatistics }) => ({
    ...state,
    genderAgeStatistics: genderAgeStatistics,
    loading: false,
  })),
  on(invokeViewsByAgeRangeAndGenderByAd, (state) => ({
    ...state,
    loadingByAgeRangeAndGenderByAd: true,
  })),
  on(invokeGlobalStatisticsForLP, (state, { companyName }) => ({
    ...state,
    loadingGlobalStatics: true,
  })),
  on(resultGlobalStatisticsForLP, (state, { resultGlobalStatisticsForLP }) => ({
    ...state,
    resultGlobalStatisticsForLP: resultGlobalStatisticsForLP,
    loadingGlobalStatics: false,
  })),
  on(invokeUniqueConsumers, (state) => ({
    ...state,
    loadingConsumers: true,
  })),
  on(resultUniqueConsumers, (state, { uniqueConsommers }) => ({
    ...state,
    uniqueConsommers: uniqueConsommers,
    loadingConsumers: false,
  })),
  on(resultGenderAgeStatistics, (state, { genderAgeStatistics }) => ({
    ...state,
    genderAgeStatistics: genderAgeStatistics,
    loading: false,
  })),
  on(resultConsumersByAgeAndGenderForLP, (state, { genderAgeStatistics }) => ({
    ...state,
    genderAgeStatisticsForMap: genderAgeStatistics,
    loading: false,
  })),
  on(
    resultCompletedByGenderDemographicForLocationPartner,
    (state, { genderAgeStatistics }) => ({
      ...state,
      genderAgeStatistics: genderAgeStatistics,
      loading: false,
    })
  ),

  on(invokeRetentionRateByWeeks, (state, { email, filter }) => ({
    ...state,
    loadingRetentionRate: true,
  })),
  on(resultRetentionRateByWeeks, (state, { retentionRate }) => ({
    ...state,
    retentionRate: retentionRate,
    loadingRetentionRate: false,
  })),
  on(invokeRetainedConsumers, (state, { email }) => ({
    ...state,
    loadingRetainedConsumer: true,
  })),
  on(resultRetainedConsumers, (state, { consumers }) => ({
    ...state,
    consumers: consumers,
    loadingRetainedConsumer: false,
  })),
  on(
    invokeSummaryChartInDayForAd,
    (state, { campaignHashedId, isFinished, day }) => ({
      ...state,
      loadingSummaryStatistics: true,
    })
  ),
  on(invokeSummaryChartInDayForLP, (state, { email, day }) => ({
    ...state,
    loadingSummaryStatistics: true,
  })),
  on(
    invokeCompletedByGenderDemographicForLocationPartner,
    (state, { email }) => ({
      ...state,
      loading: true,
    })
  ),
  on(
    invokeViewsByGenderDemographicForLocationPartners,
    (state, { email }) => ({
      ...state,
      loading: true,
    })
  ),
  on(
    invokeCompletedByAgeRangeAndGenderForAd,
    (state, { campaignHashedId }) => ({
      ...state,
      loading: true,
    })
  ),

  on(invokeFranchiseSummaryStatisticsBetweenDates, (state) => ({
    ...state,
    loadingSummaryStatistics: true,
  })),

  on(invokeFranchiseGlobalStatistics, (state) => ({
    ...state,
    loadingGlobalStatics: true,
  })),

  on(invokeLocationPartnerGlobalStatistics, (state) => ({
    ...state,
    loadingGlobalStatics: true,
  })),

  on(resultGlobalStatistics, (state, { audienceStatistics }) => ({
    ...state,
    audienceStatistics: audienceStatistics,
    loadingGlobalStatics: false,
  })),
  on(
    invokeClicksByGenderDemographicForLocationPartner,
    (state, { email }) => ({
      ...state,
      loading: true,
    })
  ),
);
